<template>
  <div class="mb-10 bg-white rounded-xl px-4 py-3 gap-2">
    <shimmer-categories v-if="loading" />
    <div v-else class="flex flex-wrap gap-2">
      <button
        v-for="item in currentCategories"
        :key="item?.id"
        class="font-bold py-2 px-4 transition-all duration-200 hover:bg-sky-50 hover:text-sky-400 rounded-xl text-gray-500"
        :class="{'bg-sky-200': category?.id === item.id}"
        @click="$emit('change', {value: item}), (category = item)"
      >
        {{ item?.name }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const category = ref<Record<string, any>>({id: undefined, name: "الكل"});

defineEmits(["change"]);

const {categories, loading} = useBusinessCategory();

const currentCategories = computed(() => {
  return categories?.value?.length
    ? [{id: undefined, name: "الكل"}, ...categories?.value]
    : [];
});
</script>
